module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "main"
  }, [_c('div', {
    staticClass: "pay-main-warp column"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticStyle: {
      "margin-bottom": "20px"
    }
  }, [_c('div', {
    staticClass: "home-btn",
    staticStyle: {
      "cursor": "pointer"
    },
    on: {
      "click": function($event) {
        return _vm.goPage('/')
      }
    }
  }, [_vm._v("\n        マイページへ\n      ")])]), _vm._v(" "), _c('div', {
    staticClass: "lists-box row m-column"
  }, [(_vm.info.priceCount) ? _c('div', {
    staticClass: "lists-item column"
  }, [_c('div', {
    staticClass: "title",
    domProps: {
      "textContent": _vm._s(_vm.info.name)
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "price-box row"
  }, [_c('div', {
    staticClass: "price",
    domProps: {
      "textContent": _vm._s(_vm.monthPlan)
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "price-box row"
  }, [_c('div', {
    staticClass: "price",
    domProps: {
      "textContent": _vm._s(_vm.annualPlan)
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "des",
    domProps: {
      "innerHTML": _vm._s(_vm.info.describe)
    }
  }, [_vm._v("\n          お試しプランでまずチームメンバーとゲームしよう！\n        ")]), _vm._v(" "), _vm._l((_vm.info.jurisdiction), function(item, index) {
    return _c('div', {
      staticClass: "item-list"
    }, [_c('i', {
      staticClass: "el-icon-success"
    }), _vm._v(" " + _vm._s(item) + "\n        ")])
  }), _vm._v(" "), _vm._m(1)], 2) : _c('div', {
    staticClass: "lists-item column"
  }, [_c('div', {
    staticClass: "title",
    domProps: {
      "textContent": _vm._s(_vm.info.name)
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "price-box row"
  }, [_c('div', {
    staticClass: "price",
    domProps: {
      "innerHTML": _vm._s(_vm.info.price)
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "des",
    domProps: {
      "textContent": _vm._s(_vm.info.describe)
    }
  }, [_vm._v("\n          お試しプランでまずチームメンバーとゲームしよう！\n        ")]), _vm._v(" "), _vm._l((_vm.info.jurisdiction), function(item, index) {
    return _c('div', {
      staticClass: "item-list"
    }, [_c('i', {
      staticClass: "el-icon-success"
    }), _vm._v(" " + _vm._s(item) + "\n        ")])
  }), _vm._v(" "), _vm._m(2)], 2), _vm._v(" "), _c('div', {
    staticClass: "edits m-column"
  }, [(_vm.info.priceCount) ? _c('div', {
    staticClass: "over-Time"
  }, [_vm._v("\n          契約期間：" + _vm._s(_vm.startTime) + " - " + _vm._s(_vm.endTime) + "\n        ")]) : _vm._e(), _vm._v(" "), _c('div', {
    staticStyle: {
      "display": "flex",
      "justify-content": "center",
      "margin-bottom": "20px"
    }
  }, [_c('el-button', {
    staticClass: "editbtn",
    on: {
      "click": function($event) {
        return _vm.goPage('/pay/index')
      }
    }
  }, [_vm._v("別のプランを確認")])], 1), _vm._v(" "), _c('div', {
    staticStyle: {
      "display": "flex",
      "justify-content": "center",
      "margin-bottom": "20px"
    }
  }, [(_vm.plan != '1on1プラン' && _vm.plan != '基本プラン') ? _c('el-button', {
    staticClass: "editbtn",
    on: {
      "click": function($event) {
        return _vm.goPage(
          '/pay/seturl?price=' + _vm.info.priceCount + '&name=' + _vm.info.name
        )
      }
    }
  }, [_vm._v("固定URLの設定")]) : _vm._e()], 1), _vm._v(" "), (_vm.info.priceCount) ? _c('div', {
    staticStyle: {
      "text-align": "center"
    }
  }, [_c('span', {
    staticClass: "release",
    on: {
      "click": _vm.showMask
    }
  }, [_vm._v("解約する")])]) : _vm._e()])])]), _vm._v(" "), _c('el-dialog', {
    staticStyle: {
      "border-radius": "15px"
    },
    attrs: {
      "title": "基本プラン",
      "visible": _vm.centerDialogVisible,
      "custom-class": "confirmContent",
      "top": "30vh",
      "width": "378px",
      "center": ""
    },
    on: {
      "update:visible": function($event) {
        _vm.centerDialogVisible = $event
      }
    }
  }, [_c('span', [_vm._v("お試しプランでまずチームメンバーとゲームしよう！")]), _vm._v(" "), _c('div', {
    staticClass: "colbtns"
  }, [_c('el-button', {
    staticClass: "join-btn",
    staticStyle: {
      "font-weight": "700 !important"
    }
  }, [_vm._v("1ヶ月プラン")]), _vm._v(" "), _c('el-button', {
    staticClass: "join-btn",
    staticStyle: {
      "font-weight": "700 !important"
    }
  }, [_vm._v("1年プラン")])], 1)]), _vm._v(" "), _c('el-dialog', {
    staticStyle: {
      "border-radius": "15px"
    },
    attrs: {
      "title": "解約しますか",
      "visible": _vm.dialogSettingVisible,
      "custom-class": "confirmContent",
      "top": "30vh",
      "width": "378px",
      "center": ""
    },
    on: {
      "update:visible": function($event) {
        _vm.dialogSettingVisible = $event
      }
    }
  }, [_c('span', [_vm._v("お試しプランでまずチームメンバーとゲームしよう！")]), _vm._v(" "), _c('div', {
    staticClass: "colbtns"
  }, [_c('el-button', {
    staticClass: "join-btn",
    staticStyle: {
      "font-weight": "700 !important"
    },
    on: {
      "click": function($event) {
        return _vm.rescind()
      }
    }
  }, [_vm._v("解約する")]), _vm._v(" "), _c('el-button', {
    staticClass: "join-btn",
    staticStyle: {
      "font-weight": "700 !important"
    },
    on: {
      "click": function($event) {
        return _vm.toClose()
      }
    }
  }, [_vm._v("キャンセル")])], 1)])], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "title-box"
  }, [_c('div', {
    staticClass: "title"
  }, [_vm._v("料金プランを確認")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "btns-box row row-center"
  }, [_c('div', {
    staticClass: "join-btn",
    staticStyle: {
      "font-weight": "700 !important",
      "text-align": "center",
      "box-sizing": "border-box",
      "padding": "8px 0"
    }
  }, [_vm._v("\n            利用中\n          ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "btns-box row row-center"
  }, [_c('div', {
    staticClass: "join-btn",
    staticStyle: {
      "font-weight": "700 !important",
      "text-align": "center",
      "box-sizing": "border-box",
      "padding": "8px 0"
    }
  }, [_vm._v("\n            利用中\n          ")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-0b9acffa"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/pay/Choose.vue
// module id = 880
// module chunks = 1